<div class="mb-1 small text-body-secondary">
  <i [class]="[iconType, icon]" *ngIf="icon"></i>
  {{ key }}
</div>
<p [class]="contentClass">
  <ng-content></ng-content>
  {{ value }} &nbsp;
</p>
